import moment from "moment";
import { TdateFilterConfig } from "./_type";
import { formatWeekTime } from '@home/pages/studio/utils';

export const ShortcutOptionDay = {
  date: [
    {
      name: 'Last 7 Days',
      type: 'last7Days',
      timeType: 'date',
      nameCN: '最近7天',
      value: [moment().subtract(7, 'day'), moment().subtract(1, 'day')],
      onClick: () => {
        return [moment().subtract(7, 'day'), moment().subtract(1, 'day')];
      }
    },
    {
      name: 'Last 30 Days',
      nameCN: '最近30天',
      type: 'last30Days',
      timeType: 'date',
      value: [moment().subtract(30, 'day'), moment().subtract(1, 'day')],
      onClick: () => {
        return [moment().subtract(30, 'day'), moment().subtract(1, 'day')];
      }
    },
    {
      name: 'Last 90 Days',
      nameCN: '最近90天',
      type: 'last90Days',
      timeType: 'date',
      value: [moment().subtract(90, 'day'), moment().subtract(1, 'day')],
      onClick: () => {
        return [moment().subtract(90, 'day'), moment().subtract(1, 'day')];
      }
    },
    {
      name: 'Last 180 Days',
      nameCN: '最近180天',
      type: 'last180Days',
      timeType: 'date',
      value: [moment().subtract(180, 'day'), moment().subtract(1, 'day')],
      onClick: () => {
        return [moment().subtract(180, 'day'), moment().subtract(1, 'day')];
      }
    },
    {
      name: 'Last 365 Days',
      nameCN: '最近365天',
      type: 'last365Days',
      timeType: 'date',
      value: [moment().subtract(365, 'day'), moment().subtract(1, 'day')],
      onClick: () => {
        return [moment().subtract(365, 'day'), moment().subtract(1, 'day')];
      }
    },
    {
      name: 'Year to Date',
      nameCN: '今年',
      type: 'yearToDate',
      timeType: 'date',
      value: [moment().startOf('year'), moment().subtract(1, 'day')],
      onClick: () => {
        return [moment().startOf('year'), moment().subtract(1, 'day')];
      }
    },
  ]
};

export const ShortcutOptionWeek = {

  week: [
    {
      name: 'This Week',
      nameCN: '本个自然周',
      type: 'thisWeek',
      timeType: 'week',
      value: [moment().weekday(0), moment().weekday(0)],
      onClick: () => [moment().weekday(0), moment().weekday(0)]
    },
    {
      name: 'Last Week',
      nameCN: '上个自然周',
      type: 'lastWeek',
      timeType: 'week',
      value: [moment().weekday(-7 * 1), moment().weekday(-1)],
      onClick: () => [moment().weekday(-7 * 1), moment().weekday(-1)]
    },
    {
      name: 'Last 4 Weeks',
      nameCN: '最近4周',
      type: 'last4Weeks',
      timeType: 'week',
      value: [moment().weekday(-7 * 4), moment().weekday(-1)],
      onClick: () => [moment().weekday(-7 * 4), moment().weekday(-1)]
    },
    {
      name: 'Last 12 Weeks',
      nameCN: '最近12周',
      type: 'last12Weeks',
      timeType: 'week',
      value: [moment().weekday(-7 * 12), moment().weekday(-1)],
      onClick: () => [moment().weekday(-7 * 12), moment().weekday(-1)]
    },
    {
      name: 'Last 24 Weeks',
      nameCN: '最近24周',
      type: 'last24Weeks',
      timeType: 'week',
      value: [moment().weekday(-7 * 24), moment().weekday(-1)],
      onClick: () => [moment().weekday(-7 * 24), moment().weekday(-1)]
    },
    // 周粒度year to date错误的选择了时间，暂时去除或隐藏该选项，后续优化后再添加
    // {
    //   name: 'Year to Date',
    //   nameCN: '今年',
    //   type: 'yearToWeek',
    //   timeType: 'week',
    //   value: [moment().startOf('year').startOf('week'), moment().weekday(6)],
    //   onClick: () => 
    //     // 取末尾为本周日，如果语言环境修改了每周的起始时间（moment.locale(）），则需重新修改
    //     [moment().startOf('year').startOf('week'), moment().weekday(6)]
      
    // },
  ]
};

// 日期筛选器配置
export const dateFilterConfig: TdateFilterConfig = {
  defaultTimeValue: [moment().startOf('week').subtract(1, 'weeks'), moment().startOf('week').subtract(1, 'weeks')],
  formatTime: formatWeekTime,
  type: 'weekly',
  isSingle: (start, end) => moment(end).diff(start, 'days') === 6,
  startOfWeek: 1,
  defualtSelectedShortcut: ShortcutOptionWeek?.week[1],
  shortcutOption: ShortcutOptionWeek,
};
